import { isDefined } from "@omni/utils/helper.utils";

import { ProductConfigurationDetailComponent } from "@/components/Product/ProductConfigurationDetail/productConfigurationDetail.component";
import { OrderItemModel } from "@/redux/modules/api/data/orderDetail/@types/orderItem.model";

type ArticleConfigurationComponentProps = {
    item: OrderItemModel;
};

const ArticleConfigurationComponent = ({
    item
}: ArticleConfigurationComponentProps) => {
    if (!isDefined(item.articleConfiguration)) return null;

    return (
        <ProductConfigurationDetailComponent
            configuration={item.articleConfiguration}
        />
    );
};

export { ArticleConfigurationComponent };
